import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, BaseForm, BaseFormService, MessageService } from '../../../core';

import { Mercado } from '../mercado';
import { mercadoSituacoes } from '../situacao';
import { MercadoCrudHttpService } from '../services';

@Component({
    selector: 'sgt-mercado-form',
    templateUrl: './mercado-form.component.html',
    styleUrls: ['./mercado-form.component.less']
})
export class MercadoFormComponent implements BaseForm<Mercado>, OnInit {
    entity: Mercado;
    editMode: boolean;

    /** Situações dos mercados */
    situacoes = mercadoSituacoes;
    @ViewChild('form') form: NgForm;

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private messageService: MessageService,
                private baseFormService: BaseFormService,
                private mercadoCrudHttpService: MercadoCrudHttpService) { }

    ngOnInit() {
        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                this.insert();
            } else {
                this.edit(id);
            }
        })
    }

    load(id: number) {
        this.mercadoCrudHttpService.load(id)
            .subscribe(
                entity => this.entity = entity,
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar o mercado', error);
                    this.cancel();
                }
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new Mercado();
        this.entity.idEmpresa = this.authService.getIdEmpresa();
    }

    edit(id: number) {
        this.editMode = true;
        this.load(id);
    }


    save() {
        this.baseFormService.save<Mercado>(this.entity, this.form, this.editMode, this.mercadoCrudHttpService)
            .then(entity => {
                this.messageService.success('', 'Mercado salvo com sucesso');
                this.afterSave(entity);
            })
            .catch(error => {});
    }

    afterSave(entity: Mercado) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }
}
